import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { MemoryCacheService } from 'app/shared/services/memory-cache/memory-cache.service';
import { BaseService } from './base.service';

/**
 * Service responsible for managing Fidelity Page operations.
 * Handles CRUD actions and caching for fidelity pages.
 * Extends BaseService to utilize common network-error handling functionality.
 */
@Injectable({
    providedIn: 'root',
})
export class FidelityPageService extends BaseService {
    protected http = inject(HttpClient);
    protected memoryCacheService = inject(MemoryCacheService);
    public disableCrudActions = signal<boolean>(false);
    public fetchingData = signal<boolean>(false);
}
